import React from 'react';
import fetch from "isomorphic-fetch";
import BiShunCanvas from "./BiShunCanvas";
import PinyinSpeaker from "./PinyinSpeaker";
import {Player} from 'video-react';
import Videojs from "video.js";

const wordStyles = <style>{`
    .searchText{
        display:flex;
        justify-content:center;
        align-items:center;
        background: #F8F8F8;
        width:90%;
        border-radius: 35px;
        margin:20px auto;
        padding:3px;
    }
    .searchText img{
        width:15px;
        height:15px;
    }
    .searchText input{
        width:90%;
        height:30px;
        border:unset;
        background: #F8F8F8;
        font-size: 14px;
        outline:none;
    }
    .searchText input::placeholder{
        color: #CBCBCB;
    }
    .blueBac{
        background: rgb(226, 244, 255);
        padding: 20px;
    }
    .whiteBac{
        background: rgb(255, 255, 255);
        width: 90%;
        margin: auto;
        border-radius: 10px;
        padding: 15px;
    }
    .title{
        color:#333;
        font-weight: bold;
        border-bottom: 4px solid #2bbdff;
        border-radius: 6px;
        display: inline;
    }
    .subtitle{
        font-size: 14px;
        color: #999999;
    }
    .detail{
        background: rgb(229, 244, 255);
        width: 94%;
        margin-top: 20px;
        padding:15px 10px;
        border-radius: 5px;
    }
    .detail > div:first-child{
        display:flex;
        justify-content:space-between;
    }
    .detail > div:last-child{
        margin-top:15px;
        letter-spacing:4px;
    }
//  视频播放
    .video-js .vjs-big-play-button{
        left:0 !important;
    }
    .video-js button{
        right:0 !important;
        margin:auto !important;
        top:40% !important;
        width:100%;
        // display:none !important
    }
    .video-js .vjs-tech{
        background:#fff;
    }
    // .video-js .vjs-play-control{
    //     // display:none !important
    //     width:100%;
    // }
    // .video-js .vjs-fullscreen-control{
    //     // display:none !important
    //     width:100%;
    // }
    // .video-js .vjs-volume-control{
    //     width:100%;
    // }

`}</style>;
export default class Word extends React.Component {
    constructor(props) {
        super(props);
        console.log(props, 'ppp')
        this.state = {
            text: '都',
            textBiShunData: null,
            textInfo: null,
            controlIndex: -1,
            videoUrl: null,
            courseID: null,
            sectionID: null,
            videoWidth: document.body.offsetWidth
        }
    };

    componentDidMount() {
        let {text} = this.state
        this.queryData(text)
    }

    queryData = (text) => {
        this.getBiShunData(text)
        this.getTextDetailInfo(text)
        this.getVideoUrl(text)
    }

    getBiShunData = (text) => {
        let url = `//bishunfile.qiaoxuesi.com/${encodeURI(encodeURI(text))}/canvasData.json`;
        let that = this;
        fetch(url).then(
            function (response) {
                if (response.status !== 200) {
                    alert('没有查询到任何内容')
                    return null;
                }
                //检查响应文本
                response.json().then(function (data) {
                    that.setState({textBiShunData: data})
                });
            }
        ).catch(function (err) {
            console.log("Fetch错误:" + err);
        });
    }

    getTextDetailInfo = (text) => {
        let url = `//bishunfile.qiaoxuesi.com/${encodeURI(encodeURI(text))}/bishun.json?random=${Math.floor(Math.random() * 10000000)}`;
        fetch(url).then(
            (response) => {
                if (response.status !== 200) {
                    return;
                }
                //检查响应文本
                response.json().then((data) => {
                    console.log(data)
                    this.setState({textInfo: data})
                });

            }
        ).catch(function (err) {
            console.log("Fetch错误:" + err);
        });
    }

    //每个笔画开始的回调函数
    loop = ({loop}) => {
        let {controlIndex} = this.state
        if (loop) {
            this.setState({controlIndex: controlIndex + 1})
        } else {
            this.setState({controlIndex: -1, loop: false, ifLast: true})
        }
    }

    getVideoUrl = (text) => {
        fetch("https://www.gankao.com/api/video/playchinese", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({char: text})
        }).then((res) => {
            res.json().then(videoData => {
                if (videoData.status === 200) {
                    this.setState({
                        videoUrl: videoData.data.videoUrl.normal,
                        courseID: videoData.data.videoUrl.course_id,
                        sectionID: videoData.data.videoUrl.section_id
                    })
                    let {videoWidth} = this.state;
                    let src = videoData.data.videoUrl.normal, height = videoWidth / 4 * 2 - 27,
                        width = videoWidth / 5 * 4 - 5.5;
                    this.player = Videojs(
                        "video",
                        {
                            height,
                            width,
                            bigPlayButton: true,
                            textTrackDisplay: false,
                            errorDisplay: false,
                            controlBar: true,
                            type: "application/x-mpegURL",
                            color: 'Blue',
                            constructor: true
                        },
                        function () {
                            this.play();
                        }
                    );
                    this.player.src({src});
                }else{
                    this.setState({videoUrl:null})
                }
            });
        });

    }

    render = () => {
        let {text, textBiShunData, textInfo, videoUrl, videoWidth} = this.state
        return (<div>
            {wordStyles}
            <div className={'searchText'}>
                <input type="text" placeholder={'请输入单个汉字'} defaultValue={text} onChange={(e) => {
                    this.setState({text: e.target.value})
                }}/>
                <img src="//img.qiaoxuesi.com/files/804_search.png" alt="" onClick={() => {
                    if (text.length === 1 && (/^[\u4e00-\u9fa5]+$/i).test(text)) {
                        this.setState({text: null})
                        // this.getVideoUrl(text)
                        this.queryData(text)
                    } else {
                        alert('请输入单个汉字');
                    }

                }}/>
            </div>

            <div className={'blueBac'}>
                <div className={'whiteBac'}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div className={'title'} style={{alignSelf: 'flex-start'}}>示例</div>
                        <div>
                            <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                {textInfo && textInfo.pinyin.length && textInfo.pinyin.map((item, index) =>
                                    <PinyinSpeaker
                                        audioSrc={`//bishunfile.qiaoxuesi.com//${encodeURI(encodeURI(text))}/pinyin`}
                                        key={"pinyinItem" + index} pinyin={item}
                                        index={index}/>)}
                            </div>

                            {textBiShunData &&
                            <BiShunCanvas key={text}
                                          splitDelay={1000}
                                          splitCallback={this.loop}
                                          fillColor={'#2ABDFF'}
                                          crossColor={'#DAF4FF'}
                                          textFillColor={'#E5E5E5'}
                                          width={220}
                                          canvasData={textBiShunData}/>}
                        </div>
                        <img src="https://img.qiaoxuesi.com/files/359_lianxi.png" alt="" style={{width: '40px'}}/>
                    </div>
                    {
                        textInfo && <div className={'detail'}>
                            <div>
                                <div><span className={'subtitle'}>结构：</span>{textInfo.structure}</div>
                                <div><span className={'subtitle'}>部首：</span>{textInfo.bushou}</div>
                                <div><span className={'subtitle'}>笔画：</span>{textInfo.bihuaCount}画</div>
                            </div>
                            <div><span style={{letterSpacing: 'unset'}}>笔顺：</span>{textInfo.bishun}</div>
                        </div>
                    }
                </div>

                <div className={'whiteBac'} style={{margin: '20px auto'}}>
                    <div className={'title'}>视频精讲</div>
                    {
                        videoUrl ?<div style={{marginTop: '20px',maxWidth:`${videoWidth}px`,}}>
                            <video id="video" className="video-js vjs-default-skin " controls  style={{maxWidth:`${videoWidth / 5 * 4 - 5.5}px`}}
                                   poster={'https://img.qiaoxuesi.com/files/11_pp.png'}></video>
                        </div>: <div>没有视频</div>
                    }

                </div>

                <div className={'whiteBac'}>
                    <div className={'title'}>释义</div>
                    <div style={{marginTop: '20px'}}>

                    </div>
                </div>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/gankao/Word.js